let gitignoreData = null;

// Create a function to preload the JSON data
function preloadGitignoreData() {
    return fetch('/content/12_free-tools/gitignore/gitignore-data/gitignore-data.json')
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            gitignoreData = data;
            return gitignoreData;
        })
        .catch(error => {
            throw new Error('Network error: ' + error.message);
        });
}

// Start loading the data immediately
const dataLoadingPromise = preloadGitignoreData();

function copyToClipboard() {
  const preElement = document.querySelector('#result pre');
  if (preElement) {
    const textToCopy = preElement.textContent;

    // Try using the Clipboard API first
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(textToCopy)
        .then(() => showCopiedFeedback())
        .catch(err => {
          console.error('Clipboard API failed:', err);
          fallbackCopyToClipboard(textToCopy);
        });
    } else {
      // Fallback for when Clipboard API is not available
      fallbackCopyToClipboard(textToCopy);
    }
  }
}

function fallbackCopyToClipboard(text) {
  // Create a temporary textarea element
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Make it invisible
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';

  document.body.appendChild(textArea);

  try {
    // Select and copy the text
    textArea.select();
    document.execCommand('copy');
    showCopiedFeedback();
  } catch (err) {
    console.error('Fallback copy method failed:', err);
  } finally {
    // Clean up
    document.body.removeChild(textArea);
  }
}

function showCopiedFeedback() {
  const copyButton = document.querySelector('.copy-button');
  if (copyButton) {
    const originalText = copyButton.textContent;
    copyButton.textContent = 'Copied!';
    setTimeout(() => {
      copyButton.textContent = originalText;
    }, 2000);
  }
}

function downloadFile() {
  const preElement = document.querySelector('#result pre');
  if (preElement) {
    const content = preElement.textContent;
    const blob = new Blob([content], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = '.gitignore';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

    // Add visual feedback
    const downloadButton = document.querySelector('.download-button');
    const originalText = downloadButton.textContent;
    downloadButton.textContent = 'Downloaded!';
    setTimeout(() => {
      downloadButton.textContent = originalText;
    }, 2000);
  }
}

let selectedTags = new Set();

function hideMostPopular() {
  const mostPopularSection = document.getElementById('mostPopular');
  if (mostPopularSection) {
    mostPopularSection.style.display = 'none';
  }
}

function removeTag(term) {
  selectedTags.delete(term);
  renderTags();

  // If no tags remain, hide the result section
  if (selectedTags.size === 0) {
    const resultDiv = document.getElementById('result');
    resultDiv.classList.remove('show');

    // Also remove the buttons if they exist
    const buttonContainers = document.querySelectorAll('.button-container');
    buttonContainers.forEach(container => container.remove());
  }
}

function renderTags() {
  const tagsContainer = document.getElementById('selectedTags');
  tagsContainer.innerHTML = '';
  selectedTags.forEach(term => {
    const tagElement = document.createElement('div');
    tagElement.className = 'tag';
    tagElement.innerHTML = `
            ${term}
            <button class="tag-remove" onclick="removeTag('${term}')">&times;</button>
        `;
    tagsContainer.appendChild(tagElement);
  });
}

document.addEventListener('DOMContentLoaded', function() {
    let allTerms = [];
    let selectedSuggestionIndex = -1;
    let visibleSuggestions = [];
    let handleFormSubmit;

    // Show loading state
    const searchInput = document.getElementById('searchInput');
    const form = document.getElementById('searchForm'); // Add this line to get the form element
    searchInput.disabled = true;
    searchInput.placeholder = 'Loading suggestions...';

    // Wait for both DOM and data to be ready
    dataLoadingPromise
        .then(data => {
            // Extract terms from the preloaded data
            allTerms = [...new Set([
                ...Object.keys(data.frameworks || {}),
                ...Object.keys(data.os || {}),
                ...Object.keys(data.environment_specific_files || {}),
                ...Object.keys(data.editors || {}),
                ...Object.keys(data.vcs || {}),
                ...Object.keys(data.build_tools || {}),
                ...Object.keys(data.package_managers || {}),
                ...Object.keys(data.security_and_credentials || {}),
                ...Object.keys(data.cicd_tools || {}),
                ...Object.keys(data.cloud_providers || {}),
                ...Object.keys(data.data_science || {}),
                ...Object.keys(data.game_engines || {})
            ])];

            // Enable input and update placeholder
            searchInput.disabled = false;
            searchInput.placeholder = 'Start typing to search...';

            // Setup your event listeners
            setupEventListeners();

            // Handle preselected language from URL
            if (window.gitignoreConfig && window.gitignoreConfig.preselectedLanguage) {
                const preselectedLang = window.gitignoreConfig.preselectedLanguage;

                // Check if the preselected language exists in our data
                if (allTerms.includes(preselectedLang)) {
                    // Add the tag
                    addTag(preselectedLang);

                    // Hide the "Most popular" section
                    hideMostPopular();

                    // Auto-generate the .gitignore file
                    handleFormSubmit();
                }
            }
        })
        .catch(error => {
            console.error('Failed to initialize:', error);
            searchInput.placeholder = 'Error loading suggestions. Please refresh.';
        });

    function setupEventListeners() {
            if (form) { // Add check to ensure form exists
                form.addEventListener('submit', handleFormSubmit);
            }
            setupSearchInput();
            setupClickOutside();
        }

    handleFormSubmit = function(e) {
        if (e) e.preventDefault();

        // Hide the "Most popular" section when generate button is clicked
        hideMostPopular();

        try {
            const searchTerms = Array.from(selectedTags)
                .map(term => term.toLowerCase())
                .filter(term => term);

            if (searchTerms.length === 0) {
                const resultDiv = document.getElementById('result');
                resultDiv.innerHTML = '<div class="error-message">⚠️ Please select at least one item to generate a .gitignore file</div>';
                resultDiv.classList.add('show');
                // Remove any existing buttons if they exist
                const existingButtons = document.querySelectorAll('.copy-button, .download-button');
                existingButtons.forEach(button => button.remove());
                // Scroll to the error message
                resultDiv.scrollIntoView({ behavior: 'smooth' });
                return;
            }

            // Use the preloaded data directly
            if (!gitignoreData) {
                throw new Error('Gitignore data not loaded yet');
            }

            const resultDiv = document.getElementById('result');
            let sections = [];
            const timestamp = new Date().toISOString().split('T')[0];
            document.getElementById('result').classList.add('show');

            // Add header
            sections.push(
                `# .gitignore file created for free with Tower (https://www.git-tower.com/)`,
                `# For suggestions or improvements please contact us using support@git-tower.com`,
                `# Generated on ${timestamp}`,
                `# Includes: ${searchTerms.join(', ')}`,
                ''
            );

            // Add universal patterns first
            sections.push(
                `### Universal ###`,
                `# Common files that should be ignored in all projects`,
                ''
            );
            sections.push(...insertEmptyLines(gitignoreData.basic.universal));
            sections.push('');

            // Process each search term
            searchTerms.forEach(searchTerm => {
                if (gitignoreData.frameworks[searchTerm]) {
                    sections.push(
                        `### ${capitalize(searchTerm)} ###`,
                        `# ${getFrameworkDescription(searchTerm)}`,
                        ''
                    );
                    sections.push(...insertEmptyLines(gitignoreData.frameworks[searchTerm]));
                    sections.push('');
                }
                if (gitignoreData.os[searchTerm]) {
                    sections.push(
                        `### ${capitalize(searchTerm)} ###`,
                        `# ${getOSDescription(searchTerm)}`,
                        ''
                    );
                    sections.push(...insertEmptyLines(gitignoreData.os[searchTerm]));
                    sections.push('');
                }
                if (gitignoreData.environment_specific_files[searchTerm]) {
                    sections.push(
                        `### ${capitalize(searchTerm)} ###`,
                        `# ${getEnvironmentDescription(searchTerm)}`,
                        ''
                    );
                    sections.push(...insertEmptyLines(gitignoreData.environment_specific_files[searchTerm]));
                    sections.push('');
                }
                if (gitignoreData.editors[searchTerm]) {
                    sections.push(
                        `### ${capitalize(searchTerm)} ###`,
                        `# ${getEditorDescription(searchTerm)}`,
                        ''
                    );
                    sections.push(...insertEmptyLines(gitignoreData.editors[searchTerm]));
                    sections.push('');
                }
                if (gitignoreData.vcs[searchTerm]) {
                    sections.push(
                        `### ${capitalize(searchTerm)} ###`,
                        `# ${getVCSDescription(searchTerm)}`,
                        ''
                    );
                    sections.push(...insertEmptyLines(gitignoreData.vcs[searchTerm]));
                    sections.push('');
                }
                if (gitignoreData.build_tools[searchTerm]) {
                    sections.push(
                        `### ${capitalize(searchTerm)} ###`,
                        `# ${getBuildToolDescription(searchTerm)}`,
                        ''
                    );
                    sections.push(...insertEmptyLines(gitignoreData.build_tools[searchTerm]));
                    sections.push('');
                }
                if (gitignoreData.package_managers[searchTerm]) {
                    sections.push(
                        `### ${capitalize(searchTerm)} ###`,
                        `# ${getPackageManagerDescription(searchTerm)}`,
                        ''
                    );
                    sections.push(...insertEmptyLines(gitignoreData.package_managers[searchTerm]));
                    sections.push('');
                }
                if (gitignoreData.security_and_credentials[searchTerm]) {
                    sections.push(
                        `### ${capitalize(searchTerm)} ###`,
                        `# ${getSecurityAndCredentialsDescription(searchTerm)}`,
                        ''
                    );
                    sections.push(...insertEmptyLines(gitignoreData.security_and_credentials[searchTerm]));
                    sections.push('');
                }
                if (gitignoreData.game_engines[searchTerm]) {
                    sections.push(
                        `### ${capitalize(searchTerm)} ###`,
                        `# ${getGameEngineDescription(searchTerm)}`,
                        ''
                    );
                    sections.push(...insertEmptyLines(gitignoreData.game_engines[searchTerm]));
                    sections.push('');
                }
                if (gitignoreData.data_science[searchTerm]) {
                    sections.push(
                        `### ${capitalize(searchTerm)} ###`,
                        `# ${getDataScienceDescription(searchTerm)}`,
                        ''
                    );
                    sections.push(...insertEmptyLines(gitignoreData.data_science[searchTerm]));
                    sections.push('');
                }
                if (gitignoreData.cloud_providers[searchTerm]) {
                    sections.push(
                        `### ${capitalize(searchTerm)} ###`,
                        `# ${getCloudProviderDescription(searchTerm)}`,
                        ''
                    );
                    sections.push(...insertEmptyLines(gitignoreData.cloud_providers[searchTerm]));
                    sections.push('');
                }
                if (gitignoreData.cicd_tools[searchTerm]) {
                    sections.push(
                        `### ${capitalize(searchTerm)} ###`,
                        `# ${getCICDToolDescription(searchTerm)}`,
                        ''
                    );
                    sections.push(...insertEmptyLines(gitignoreData.cicd_tools[searchTerm]));
                    sections.push('');
                }
                if (gitignoreData.basic[searchTerm]) {
                    sections.push(
                        `### ${capitalize(searchTerm)} ###`,
                        `# ${getBasicDescription(searchTerm)}`,
                        ''
                    );
                    sections.push(...insertEmptyLines(gitignoreData.basic[searchTerm]));
                    sections.push('');
                }
            });

            if (sections.length > 4) { // More than just the header
              const formattedOutput = sections.join('\n');
              resultDiv.innerHTML = `<pre>${formattedOutput}</pre>`;

              // Check if button containers already exist
              const existingTopButtons = resultDiv.previousElementSibling;
              const existingBottomButtons = resultDiv.nextElementSibling;

              // Add both buttons in a container
              const buttonHtml = `
                  <div class="button-container">
                      <a class="download-button button button--outlined button--primary" onclick="downloadFile()">Download File</a>
                      <a class="copy-button button button--outlined button--secondary" onclick="copyToClipboard()">Copy to Clipboard</a>
                  </div>
              `;

              // Only add top buttons if they don't exist
              if (!existingTopButtons || !existingTopButtons.classList.contains('button-container')) {
                  resultDiv.insertAdjacentHTML('beforebegin', buttonHtml);
              }

              // Only add bottom buttons if they don't exist
              if (!existingBottomButtons || !existingBottomButtons.classList.contains('button-container')) {
                  resultDiv.insertAdjacentHTML('afterend', buttonHtml);
              }

              // Auto-scroll to the result
              setTimeout(() => {
                  const bottomSection = document.querySelector('.bottom-section');
                  if (bottomSection) {
                      bottomSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  } else if (resultDiv) {
                      resultDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
              }, 200);
          } else {
              resultDiv.innerHTML = 'No matching templates found';
          }

      } catch (error) {
          console.error('Error:', error);
          const resultDiv = document.getElementById('result');
          resultDiv.textContent = 'Error processing templates';
      }
  };

  function setupSearchInput() {
    const searchInput = document.getElementById('searchInput');
    searchInput.addEventListener('input', function (e) {
      const input = e.target.value.toLowerCase();
      const suggestionsContainer = document.getElementById('suggestions');
      suggestionsContainer.innerHTML = '';
      selectedSuggestionIndex = -1; // Reset selection when input changes

      if (input.length < 1) {
        suggestionsContainer.style.display = 'none';
        visibleSuggestions = [];
        return;
      }

      // Split the filtering into two groups: starts with and contains
      const startsWithMatches = allTerms.filter(term =>
        term.toLowerCase().startsWith(input) && !selectedTags.has(term)
      );

      const containsMatches = allTerms.filter(term =>
        !term.toLowerCase().startsWith(input) && // Exclude terms that start with input
        term.toLowerCase().includes(input) &&
        !selectedTags.has(term)
      );

      // Combine the results with startsWith matches first
      visibleSuggestions = [...startsWithMatches, ...containsMatches];

      // Display suggestions
      if (visibleSuggestions.length > 0) {
        visibleSuggestions.forEach((term, index) => {
          const div = document.createElement('div');
          div.className = 'suggestion-item';
          div.textContent = term;
          div.setAttribute('data-index', index);
          div.addEventListener('click', () => {
            addTag(term);
            suggestionsContainer.style.display = 'none';
            handleFormSubmit();
          });
          suggestionsContainer.appendChild(div);
        });
        suggestionsContainer.style.display = 'block';
      } else {
        suggestionsContainer.style.display = 'none';
        visibleSuggestions = [];
      }
    });

    searchInput.addEventListener('keydown', function (e) {
      const suggestionsContainer = document.getElementById('suggestions');

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if (suggestionsContainer.style.display === 'block') {
            selectedSuggestionIndex = Math.min(selectedSuggestionIndex + 1, visibleSuggestions.length - 1);
            updateSuggestionHighlight();
          }
          break;

        case 'ArrowUp':
          e.preventDefault();
          if (suggestionsContainer.style.display === 'block') {
            selectedSuggestionIndex = Math.max(selectedSuggestionIndex - 1, -1);
            updateSuggestionHighlight();
          }
          break;

        case 'Enter':
          e.preventDefault();
          if (!this.value.trim()) {
            handleFormSubmit();
            return;
          }
          if (selectedSuggestionIndex >= 0 && selectedSuggestionIndex < visibleSuggestions.length) {
            addTag(visibleSuggestions[selectedSuggestionIndex]);
            suggestionsContainer.style.display = 'none';
            selectedSuggestionIndex = -1;
            this.value = '';
          } else if (visibleSuggestions.length > 0) {
            addTag(visibleSuggestions[0]);
            suggestionsContainer.style.display = 'none';
            this.value = '';
          }
          handleFormSubmit();
          break;
      }
    });
  }

  function setupClickOutside() {
    // Hide suggestions when clicking outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.search-container')) {
        document.getElementById('suggestions').style.display = 'none';
      }
    });
  }

  function updateSuggestionHighlight() {
    const suggestions = document.querySelectorAll('.suggestion-item');
    suggestions.forEach((suggestion, index) => {
      if (index === selectedSuggestionIndex) {
        suggestion.classList.add('selected');
      } else {
        suggestion.classList.remove('selected');
      }
    });
  }

  function getFrameworkDescription(framework) {
    const descriptions = {
      node: 'Node.js dependency directory, logs, and environment files',
      react: 'React build directory and environment files',
      python: 'Python compiled files, virtual environments, and cache',
      java: 'Java compiled files, build directories, and IDE files',
      angular: 'Angular build files, dependencies, and IDE settings',
      vue: 'Vue.js build files and development artifacts',
      django: 'Django specific files, database, and media files',
      dotnet: '.NET build outputs and development files',
      flutter: 'Flutter/Dart build files and dependencies',
      laravel: 'Laravel framework specific files and directories'
    };
    return descriptions[framework] || `${framework} specific files`;
  }

  function getOSDescription(os) {
    const descriptions = {
      windows: 'Windows operating system specific files',
      macos: 'macOS operating system specific files',
      linux: 'Linux operating system specific files'
    };
    return descriptions[os] || `${os} specific files`;
  }

  function getEnvironmentDescription(environment) {
    const descriptions = {
      docker: 'Docker environment specific files and directories',
      kubernetes: 'Kubernetes configuration and deployment files',
      terraform: 'Terraform state and configuration files'
    };
    return descriptions[environment] || `${environment} environment specific files`;
  }

  function getEditorDescription(editor) {
    const descriptions = {
      vscode: 'Visual Studio Code editor settings and workspace files',
      intellij: 'IntelliJ IDEA editor files and settings',
      eclipse: 'Eclipse IDE specific files and settings',
      sublime: 'Sublime Text editor files and workspace settings',
      vim: 'Vim editor swap and temporary files',
      atom: 'Atom editor settings and workspace files',
      webstorm: 'WebStorm IDE specific files and settings',
      phpstorm: 'PhpStorm IDE specific files and settings',
      xcode: 'Xcode IDE files and build settings',
      androidstudio: 'Android Studio IDE files and settings'
    };
    return descriptions[editor] || `${editor} editor specific files`;
  }

  function getVCSDescription(vcs) {
    const descriptions = {
      git: 'Git version control system files and directories',
      svn: 'Subversion version control system files',
      mercurial: 'Mercurial version control system files',
      cvs: 'CVS version control system files',
      bazaar: 'Bazaar version control system files'
    };
    return descriptions[vcs] || `${vcs} version control system files`;
  }

  function getBuildToolDescription(buildTool) {
    const descriptions = {
      maven: 'Maven build tool files and directories',
      gradle: 'Gradle build tool files and directories',
      ant: 'Apache Ant build tool files',
      webpack: 'Webpack build configuration and cache',
      gulp: 'Gulp build tool files and dependencies',
      grunt: 'Grunt build tool files and configurations',
      babel: 'Babel transpiler configuration and cache',
      make: 'Make build system files and outputs',
      cmake: 'CMake build system files and cache'
    };
    return descriptions[buildTool] || `${buildTool} build tool specific files`;
  }

  function getPackageManagerDescription(packageManager) {
    const descriptions = {
      npm: 'NPM package manager files and directories',
      yarn: 'Yarn package manager files and cache',
      pip: 'Python pip package manager files',
      composer: 'PHP Composer package manager files',
      nuget: 'NuGet package manager files and packages',
      cargo: 'Rust Cargo package manager files',
      gem: 'Ruby gems package manager files',
      maven: 'Maven package manager repository files',
      cocoapods: 'CocoaPods package manager files',
      pub: 'Dart/Flutter pub package manager files'
    };
    return descriptions[packageManager] || `${packageManager} package manager specific files`;
  }

  function getSecurityAndCredentialsDescription(securityItem) {
    const descriptions = {
      ssh: 'SSH keys and configuration files',
      ssl: 'SSL certificates and private keys',
      apikeys: 'API keys and access tokens',
      env: 'Environment files containing sensitive data',
      credentials: 'Various credential files and tokens',
      certificates: 'Digital certificates and related files',
      secrets: 'Secret management files and configurations',
      keys: 'Encryption and signing keys',
      passwords: 'Password files and configurations',
      tokens: 'Authentication and access tokens'
    };
    return descriptions[securityItem] || `${securityItem} security related files`;
  }

  function getGameEngineDescription(engine) {
    const descriptions = {
      unreal_engine: 'Unreal Engine generated files and build artifacts',
      unity: 'Unity engine generated files and build outputs',
      godot: 'Godot engine project files and build artifacts',
      cryengine: 'CryEngine generated files and build outputs',
      lumberyard: 'Amazon Lumberyard engine files and artifacts',
      gamemaker: 'GameMaker Studio files and build outputs',
      rpg_maker: 'RPG Maker project files and artifacts',
      construct: 'Construct engine files and backups',
      phaser: 'Phaser framework build files and artifacts',
      cocos2d: 'Cocos2d engine files and build outputs'
    };
    return descriptions[engine] || `${engine} specific files`;
  }

  function getDataScienceDescription(tool) {
    const descriptions = {
      jupyter: 'Jupyter Notebook checkpoints and temporary files',
      rstudio: 'RStudio project files and R environment',
      spyder: 'Spyder IDE project settings and files',
      anaconda: 'Anaconda environment files and configurations',
      sagemath: 'SageMath specific files and outputs',
      matlab: 'MATLAB autosave and temporary files',
      tableau: 'Tableau workbook and data files',
      powerbi: 'Power BI template and data files'
    };
    return descriptions[tool] || `${tool} specific files`;
  }

  function getCloudProviderDescription(provider) {
    const descriptions = {
      aws: 'AWS credentials and configuration files',
      gcp: 'Google Cloud Platform service accounts and configs',
      azure: 'Azure configuration and credential files',
      oracle_cloud: 'Oracle Cloud Infrastructure configurations',
      ibm_cloud: 'IBM Cloud credentials and settings',
      digitalocean: 'DigitalOcean configuration files',
      heroku: 'Heroku configuration and environment files',
      cloudflare: 'Cloudflare credentials and configurations'
    };
    return descriptions[provider] || `${provider} specific files`;
  }

  function getCICDToolDescription(tool) {
    const descriptions = {
      jenkins: 'Jenkins pipeline and configuration files',
      github_actions: 'GitHub Actions workflows and configurations',
      gitlab_ci: 'GitLab CI configuration and cache files',
      circle_ci: 'CircleCI configuration and build files',
      travis_ci: 'Travis CI configuration and build files',
      azure_devops: 'Azure DevOps pipeline configurations',
      teamcity: 'TeamCity build configurations and settings',
      bamboo: 'Bamboo CI server configurations and specs'
    };
    return descriptions[tool] || `${tool} specific files`;
  }

  function getBasicDescription(type) {
    const descriptions = {
      universal: 'Universal patterns that should be in every .gitignore'
    };
    return descriptions[type] || `${type} specific files`;
  }

  function capitalize(term) {
    return term.charAt(0).toUpperCase() + term.slice(1);
  }

  function insertEmptyLines(patterns) {
    const groupedPatterns = [];
    patterns.forEach((pattern, index) => {
      groupedPatterns.push(pattern);
      if ((index + 1) % 5 === 0 && index !== patterns.length - 1) {
        groupedPatterns.push('');
      }
    });
    return groupedPatterns;
  }

  function initializeTerms() {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', '/content/12_free-tools/gitignore/gitignore-data/gitignore-data.json', true);
        xhr.onload = function () {
            if (xhr.status === 200) {
                try {
                    const data = JSON.parse(xhr.responseText);
                    const terms = [
                        ...Object.keys(data.frameworks || {}),
                        ...Object.keys(data.os || {}),
                        ...Object.keys(data.environment_specific_files || {}),
                        ...Object.keys(data.editors || {}),
                        ...Object.keys(data.vcs || {}),
                        ...Object.keys(data.build_tools || {}),
                        ...Object.keys(data.package_managers || {}),
                        ...Object.keys(data.security_and_credentials || {}),
                        ...Object.keys(data.cicd_tools || {}),
                        ...Object.keys(data.cloud_providers || {}),
                        ...Object.keys(data.data_science || {}),
                        ...Object.keys(data.game_engines || {})
                    ];
                    resolve([...new Set(terms)]);
                } catch (error) {
                    console.error('Error parsing JSON:', error);
                    reject(error);
                }
            } else {
                console.error('Error loading terms:', xhr.status);
                reject(new Error(`HTTP error! status: ${xhr.status}`));
            }
        };
        xhr.onerror = function () {
            console.error('Error initializing terms');
            reject(new Error('Failed to fetch terms'));
        };
        xhr.send();
    });
  }

  function addTag(term) {
    if (!selectedTags.has(term)) {
      selectedTags.add(term);
      const tagsContainer = document.getElementById('selectedTags');
      const tagElement = document.createElement('div');
      tagElement.className = 'tag';
      tagElement.innerHTML = `
              ${term}
              <button class="tag-remove" onclick="removeTag('${term}')">&times;</button>
          `;
      tagsContainer.appendChild(tagElement);
    }
    document.getElementById('searchInput').value = '';
    document.getElementById('suggestions').innerHTML = '';
  }
});
